import { Component, OnInit } from '@angular/core';
import { CatFichaInmaterial } from 'src/app/models/CatFichaInmaterial';
import { FichaInmaterialService } from 'src/app/services/ficha-inmaterial.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-lista-fichas-inmateriales',
  templateUrl: './lista-fichas-inmateriales.component.html',
  styleUrls: ['./lista-fichas-inmateriales.component.css']
})
export class ListaFichasInmaterialesComponent implements OnInit {

  catFichasInmateriales: CatFichaInmaterial[];

  title: string = 'Lista de Fichas Inmateriales';  

  constructor(
    private catFichaInmaterialService: FichaInmaterialService
  ) { }

  ngOnInit() {

    this.catFichaInmaterialService.cargarFichasInmateriales()
      .subscribe((res) => {
        this.catFichasInmateriales = res;
        console.log('Fichas Inmateriales', res)
    }
    )

  }

  delete(ficha: CatFichaInmaterial){
    Swal.fire({
      title: 'Are you sure?',
      text: `You won't be able to revert this! Ficha: ${ficha.codregistro}/${ficha.nombre_manifestacion}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {

        this.catFichaInmaterialService.eliminarFichaInmaterial(ficha.id).subscribe(
          response => {

            this.catFichasInmateriales=this.catFichasInmateriales.filter(
              fich => fich !== ficha
            )

            Swal.fire(
              'Deleted!',
              'Your file has been deleted.',
              'success'
            )
          }
        )

        
      }
    })

  }

}
